module.exports = __webpack_public_path__ + "static/brick-product-alt-9ec67ece4501d76169da74cc910ef45f.jpg";